import { useParams, useOutletContext, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { FormGroup, Input, Label, Button } from 'reactstrap';

import {translations} from './../../i18/translations.js';
import { getRoutePathList } from "./../../RouteConfig";

const MenuManagementEdit = () => {

    const API_URL = process.env.REACT_APP_SERVICE_API_URL;
    const {user, lang, showAlert, checkAccess} = useOutletContext();
    const {id, parentId} = useParams();
    const navigate = useNavigate();

    const [contentList, setContentList] = useState([]);
    const [featureList, setFeatureList] = useState([]);
    const [menu, setMenu] = useState([]);

    const fileContentPaths = getRoutePathList();

    const fetchData = async () => {
        try {
            const payload = {
                menu: {
                    id: id,
                    parentId: parentId
                }
            };
            const response = await fetch(`${API_URL}/admin/get_menu_data_by_id.php`, {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify(payload)
            });
            const data = await response.json();
            if (checkAccess(data)) {
                setMenu(data.menu);
                setContentList(data.contentList);
                setFeatureList(data.featureList);
            }
        } catch (error) {
            console.error("Error fetching menu:", error);
        }
    };

    const save = async () => {
        try {
            const payload = {
                menu: menu
            };
            const response = await fetch(`${API_URL}/admin/save_menu.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });
            const data = await response.json();
            if (checkAccess(data)) {
                showAlert(data.alert);
                fetchData();
            }
        } catch (error) {
            console.error("Error save content:", error);
        }
    };

    const back = () => {
        navigate("/MenuManagement/" + parentId);
    };

    useEffect(() => {
        fetchData();
    }, [id, lang, user]);

    const handleMenuChange = (e) => {
        const {id, value, type, checked} = e.target;
        setMenu((prevData) => ({
                ...prevData,
                [id]: type === 'checkbox' ? checked : value
            }));
    };

    return (
            <div classname="mbkegy-content">
                <h1 className="mbkegy-content">{translations[lang].menu_management}</h1>
            
            
                {menu && <>
                <FormGroup floating>
                    <Input id="parent" type="text" rows="3" value={menu.parent} disabled/>
                    <Label for="parent">{translations[lang].menu_parent}</Label>
                </FormGroup>
                <FormGroup floating>
                    <Input type="select" id="access_feature_id" value={menu.access_feature_id} onChange={handleMenuChange}>
                    <option key="" value="">{translations[lang].feature_access_none}</option>
                    {featureList.map((f, index) => (
                                        <option key={index} value={f.id}>[{f.id}] {f.name}</option>
                                                ))}
                    </Input>
                    <Label for="access_feature_id">{translations[lang].menu_access}</Label>
                </FormGroup>
                <FormGroup floating>
                    <Input id="label_hu" type="text" rows="3" value={menu.label_hu} onChange={handleMenuChange}/>
                    <Label for="label_hu">{translations[lang].menu_label} [HU]</Label>
                </FormGroup>
                <FormGroup floating>
                    <Input id="label_en" type="text" rows="3" value={menu.label_en} onChange={handleMenuChange}/>
                    <Label for="label_en">{translations[lang].menu_label} [EN]</Label>
                </FormGroup>
                <FormGroup switch>
                    <Input id="visible" type="switch" checked={menu.visible} onChange={handleMenuChange}/>
                    <Label for="visible">{translations[lang].menu_visible}</Label>
                </FormGroup>  
                <FormGroup switch>
                    <Label for="is_file_content">{translations[lang].menu_file_content}</Label>
                    <Input id="is_file_content" type="switch" checked={menu.is_file_content} onChange={handleMenuChange}/>
                </FormGroup>  
                <FormGroup floating>
                    {!menu.is_file_content && <Input type="select" id="content" value={menu.content} onChange={handleMenuChange}>
                    <option value="">Nincs</option>
                    {contentList.map((c, index) => (
                                                <option key={index} value={c.id}>[{c.id}] {c.description}</option>
                                                        ))}
                    </Input>}
                    {menu.is_file_content && <Input type="select" id="content" value={menu.content} onChange={handleMenuChange}>
                    <option value="">Nincs</option>
                    {fileContentPaths.map((c, index) => (
                                                <option key={index} value={c}>{c}</option>
                                                        ))}
                    </Input>}
                    <Label for="content">{translations[lang].menu_content}</Label>
                </FormGroup>
                <FormGroup floating>
                    <Input id="order_index" type="text" rows="3"  value={menu.order_index} onChange={handleMenuChange}/>
                    <Label for="order_index">{translations[lang].order_index}</Label>
                </FormGroup>  
            
            
                <Button color="primary" title={translations[lang].anew} onClick={() => save()}>{translations[lang].save}</Button>
                <Button onClick={() => back()}>{translations[lang].back}</Button>
            
                </>
                }
            
            
            
            </div>
            );
};

export default MenuManagementEdit;